<div class="filters-bar-container filters-bar-card">
    <zui-filters-bar *ngIf="filterList && filterList.length"
      [filterList]="filterList"
      [companyId]="currentSelectedCompanyId"
      (OnFilterChanged)="handleFiltersBarSelections($event)">
    </zui-filters-bar>
</div>
